import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const Bars = ({ value, width = '34px', height = '19px' }) => (
  <svg
    className={cx(`bars-${value}`)}
    width={width}
    height={height}
    viewBox='0 0 34 19'
  >
    <g id='round2' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='pdp_proi_bars'
        transform='translate(-1110.000000, -278.000000)'
        fill='#DAE0E3'
      >
        <g id='Group-4' transform='translate(786.000000, 221.000000)'>
          <g id='Group-6-Copy' transform='translate(324.000000, 57.000000)'>
            <polygon points='7 15 7 19 0 19' />
            <polygon points='9 14 16 10 16 19 9 19' />
            <polygon points='18 9 25 5 25 19 18 19' />
            <polygon points='27 4 34 -2.27373675e-13 34 19 27 19' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

Bars.propTypes = {
  value: PropTypes.number.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Bars
